"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Person = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const Person = () => {
    return ((0, jsx_runtime_1.jsxs)("svg", Object.assign({ xmlns: "http://www.w3.org/2000/svg", width: "192", height: "192", fill: "currentcolor", viewBox: "0 0 256 256" }, { children: [(0, jsx_runtime_1.jsx)("circle", { cx: "128", cy: "96", r: "64", fill: "none", stroke: "currentcolor", strokeMiterlimit: "10", strokeWidth: "16" }), (0, jsx_runtime_1.jsx)("path", { d: "M31,216a112,112,0,0,1,194,0", fill: "none", stroke: "currentcolor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "16" })] })));
};
exports.Person = Person;
